<div class="filter">
  <section class="section">
    <div class="shortcut-menu card card--no-padding">
      <div class="shortcut-menu__header">
        <h3>{{ "ShortcutMenu.Title" | translate }}</h3>
      </div>
      <div class="shortcut-menu__body">
        <wireless-tickets-item [tickets]="tickets()" scope="organisation" />
        <wireless-suppliers-item [suppliers]="suppliers()" />
      </div>
    </div>
  </section>

  <section class="section">
    <div class="input__wrapper">
      <input
        type="search"
        [(ngModel)]="servicesSearch"
        value=""
        class="input input--search"
        name=""
        placeholder="{{ 'Form.Placeholder.SearchTerm' | translate }}"
      />
    </div>
  </section>

  <subscriptions-tags-filter [collectedTags]="collectedTags()" />
</div>
